import React from "react";

import type { CustomCellRendererProps } from "ag-grid-react";
import { IWeightPullWeighIn } from "@eagerdog/interfaces";

import Button from "src/components/Button/Button";

import styles from "./WeighInsModal.module.scss";

interface IEnterWeightCellRendererProps extends CustomCellRendererProps<IWeightPullWeighIn> {
  onEnterWeight(row: IWeightPullWeighIn): void;
}

export const EnterWeightCellRenderer = (props: IEnterWeightCellRendererProps) => {
  if (!props.data) {
    return null;
  }

  return (
    <div className={styles.EnterWeightCellRenderer}>
      <Button onClick={() => props.onEnterWeight(props.data!)}>Enter Weight</Button>
    </div>
  );
};
